export default __webpack_public_path__ + "static/media/Group 11810.847620a9.svg";